import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcObjects = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M14 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V8Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.193 14.031a1 1 0 0 1 1.73-.068l4.107 6.503A1 1 0 0 1 13.185 22h-7.53a1 1 0 0 1-.884-1.466l3.422-6.503Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "6.5",
  cy: "6.5",
  fill: "var(--mds-nav-icon-accent)",
  r: "4.5"
})), "IcObjects");

export { IcObjects };
//# sourceMappingURL=ic-objects.js.map
